import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Icon } from '@iconify/react'
import { colors } from '../tokens'

const useStyles = makeStyles({
  root: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '8px',
    width: 280,
    maxWidth: '100%',
    padding: '8px 12px',
    border: `1px solid ${colors.border}`,
    borderRadius: '8px',
    background: '#FFFFFF',
    color: colors.subtle,
  },
  icon: {
    width: 14,
    height: 14,
    flex: 'none',
  },
  input: {
    flex: 1,
    width: '100%',
    border: 0,
    outline: 'none',
    background: 'transparent',
    fontFamily: 'inherit',
    fontSize: '13px',
    color: colors.navy,
  },
})

const SearchField = ({ value, onChange, placeholder, className }) => {
  const classes = useStyles()

  return (
    <label className={`${classes.root} ${className || ''}`}>
      <Icon icon="tabler:search" className={classes.icon} />
      <input
        className={classes.input}
        value={value}
        placeholder={placeholder}
        onChange={event => onChange(event.target.value)}
      />
    </label>
  )
}

export default SearchField
